module.exports = __webpack_public_path__ + "files/74ea3295fd3069807373e5c57adc9021.png";